import React from "react";
import Skeleton from "react-loading-skeleton";
const SekletonSubjectListCalendar = () => {
  return (
    <ul className="list-unstyled m-0">
      {Array(20)
        .fill()
        .map((item, index) => (
          <li key={index}>
            <Skeleton height={25} />
          </li>
        ))}
    </ul>
  );
};
export default SekletonSubjectListCalendar;
